import { Badge, Card } from "react-bootstrap";
import no_image from "../../../images/No_Image_Available.jpg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  getLocalStorageMenuItem,
  SARIconThemeColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../../../utility";
import FavortieIcon from "./favoriteIcon";
import { t } from "i18next";

const Dishe = ({
  item,
  updataItem,
  qrCode,
  qrName,
  sympole,
  // refetch,
  handleFavorite,
  favorites,
  suggested,
  isDesktop
}) => {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const openItem = () => {
    if (item.sold_out !== 1) {
      if (location.pathname === `/${qrName}/${qrCode}/sections`) {
        navigate(
          `/${qrName}/${qrCode}/items?item=${item.id}&t=${params.get(
            "t"
          )}&suggested=1&selectedLang=${getLocalStorageMenuItem("lang")}`,
          {
            replace: true,
            state: { from: location.pathname },
          }
        );
      } else {

        updataItem(item);
      }
    }
  };

  const onImageError = (e) => {
    e.target.src = no_image;
  };

  return (
    <div
      className={`${location.pathname === `/${qrName}/${qrCode}/sections` ? "col-6" : ""
        } mb-2 m-top-12`}
    >
      <Card
        className={`${isDesktop ? 'dishe-card-disktop' : 'dishe-card'} m-auto
        } position-relative`}
        style={{
          height: item?.sold_out === 1 ? isDesktop ? "280px" : "230px" : isDesktop ? "235px" : "185px",
          backgroundColor:
            getLocalStorageMenuItem("theme") === "dark" ||
              getLocalStorageMenuItem("theme") === "light" ||
              getLocalStorageMenuItem("theme") === "costomize"
              ? setMobileCardColor()
              : "",
          borderColor: setMobileCardBorderColor(),
          borderWidth: 1,
        }}
      >
        <div className={item.sold_out === 1 ? "" : ""}></div>

        {item.sold_out === 1 && (
          <Badge
            style={{
              top: "22%",
              right: "22%",
            }}
            className={`${item.sold_out === 1 ? "d-block" : "d-none"
              } outofinstock-badge-style p-2 font-size-12 sub-font m-1 position-absolute`}
          >
            {t("Out of stock")}
          </Badge>
        )}
        <img
          className="cursor card-img-responsive"
          src={item.image ? item.image : no_image}
          onError={onImageError}
          onClick={openItem}
          style={{ borderRadius: 16 }}
        />

        <Card.Body
          className={`position-relative p-0 pt-2`}
          style={{ color: setMobileTextColor() }}
        >
          <Card.Title
            className="font-size-12 cursor fw-bold m-top-12 head-font alignByLang"
            onClick={openItem}
          >
            {item.name && item.name.length >= 20
              ? item.name.slice(0, 20) + "..."
              : item.name}
          </Card.Title>

          <div
            className={`ps-0 ${getLocalStorageMenuItem("lang") === "ar"
              ? "dishe-card-price-ar"
              : "dishe-card-price-en"
              } sub-font`}
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <FavortieIcon
              item={item}
              handleFavorite={handleFavorite}
              favorites={favorites}
              suggested={suggested}
            />
            {item.has_price_options ? (
              <strong
                className="head-font"
                style={{
                  color:
                    getLocalStorageMenuItem("theme") === "costomize"
                      ? setMobileTextColor()
                      : "#6ba5f2 ",
                  fontSize: 13,
                  marginTop: "auto",
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                {item.lowest_price_option
                  ? t("STARTS AT") + " " + item.lowest_price_option
                  : item.price || 0}{" "}
                {sympole ? sympole === "SAR" ? <img style={{
                  marginLeft: getLocalStorageMenuItem("lang") === "ar" ||
                    getLocalStorageMenuItem("lang") === "fa" ? '0' : '5px',
                  marginRight: getLocalStorageMenuItem("lang") === "ar" ||
                    getLocalStorageMenuItem("lang") === "fa" ? '5px' : '0',
                }} width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympole : ""}

              </strong>
            ) : (
              <strong
                className="head-font"
                style={{
                  color:
                    getLocalStorageMenuItem("theme") === "costomize"
                      ? setMobileTextColor()
                      : "#6ba5f2 ",
                  fontSize: 13,
                  marginTop: "auto",
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                {" "}
                {item?.price}{" "}
                {item?.old_price > 0 && (
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "red",
                    }}
                  >
                    {item.old_price || ""}
                    {"adel_1"}
                  </span>
                )}{" "}
                {sympole ? sympole === "SAR" ? <img style={{
                  marginLeft: getLocalStorageMenuItem("lang") === "ar" ||
                    getLocalStorageMenuItem("lang") === "fa" ? '0' : '5px',
                  marginRight: getLocalStorageMenuItem("lang") === "ar" ||
                    getLocalStorageMenuItem("lang") === "fa" ? '5px' : '0',
                }} width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : sympole : ""}

              </strong>
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Dishe;
